import { FixedIp } from 'cloud-networks/modules/RoutersModule/RoutersModule.types';

export type Port = {
    allowed_address_pairs: AllowedAddressPairs[];
    extra_dhcp_opts: [];
    updated_at: string;
    device_owner: string;
    revision_number: number;
    port_security_enabled: boolean;
    fixed_ips: FixedIp[];
    id: string;
    security_groups: string[];
    mac_address: string;
    project_id: string;
    status: PortStatus;
    description: string;
    tags: [];
    dns_assignment: DnsAssignment[];
    device_id: string;
    name: string;
    admin_state_up: boolean;
    network_id: string;
    dns_name: string;
    created_at: string;
    'binding:vnic_type': string;
    tenant_id: string;
};

export enum DeviceOwner {
    dhcp = 'network:dhcp',
    router = 'network:router',
    snat = 'network:router_centralized_snat',
    interfaceDistributed = 'network:router_interface_distributed',
}

type AllowedAddressPairs = {
    ip_address: string;
    mac_address: string;
};

type DnsAssignment = {
    hostname: string;
    ip_address: string;
};

export type PortCreateData = {
    networkId?: string;
    subnetId?: string;
    securityGroupIds?: string[];
    ip?: string;
    dnsName?: string;
    name?: string;
};

enum PortStatus {
    ACTIVE = 'ACTIVE',
}
